import React from 'react';
import './Header.css'
import ashab from '../../images/ashab.jpg'
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
const resumeURL = `drive.google.com/file/d/1tAIPp68onvDwA-SlOWDWU6xY_liz-2mx/view?usp=sharing`;

const Header = () => {
    return (
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <img id='header-img' className='animate__animated animate__backInLeft ' src={ashab} alt="" />
            </div>

            <div className="col-md-6 col-sm-12 header-text">
                <h3 id="name" className=''>I'm Ashab Hussan</h3>
                <h1 id='post' className=''> Web Developer</h1>

                <h5>I am a Web Developer who loves Problem Solving and always learning new things.</h5>

                <Link target='_blank' to={"//" + resumeURL} ><Button className='mt-5 ' variant='info'><FontAwesomeIcon icon={faDownload} /> Get Resume</Button></Link>
            </div>


        </div>
    );
};

export default Header;